import { useState } from "react";
import Layout from "../Shared/Layout";
import Banner from "./Banner";
import Category from "./Categoty";
import CustomerSaySection from "./CustomerSaySection";
import Occasion from "./Occasion";
import ProductDetailSection from "./ProductDetailSection";
import RecommendedProduct from "./RecommendedProduct";
import ServicesSection from "./ServicesSection";
import TopProducts from "./TopProducts";

const Home = () => {

    return (
        <Layout>
            <div className="home_layout_container">
                <Banner />
                <Category/>
                <TopProducts/>
                <RecommendedProduct/>
                <ProductDetailSection/>
                <Occasion/>
                <CustomerSaySection/>
                <ServicesSection/>
            </div>
        </Layout>
    );
};

export default Home;
